import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useRef } from "react";
import globals from "web/script/modules/globals";
import { gettext } from "web/script/modules/django-i18n";
import classnames from "classnames";
import styles from "./ticker.css";
export function TickerText(_ref) {
  var tickerText = _ref.tickerText,
      _ref$isPresentational = _ref.isPresentational,
      isPresentational = _ref$isPresentational === void 0 ? false : _ref$isPresentational;
  return React.createElement("span", {
    className: styles.scrollingText,
    role: isPresentational ? "presentation" : undefined,
    dangerouslySetInnerHTML: {
      __html: tickerText
    }
  });
}
export default function Ticker(_ref2) {
  var speed = _ref2.speed,
      className = _ref2.className;
  var container = useRef(null);
  var text = useRef(null);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      repeatedTexts = _useState2[0],
      setRepeatedTexts = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      textWidth = _useState4[0],
      setTextWidth = _useState4[1];

  var tickerText = gettext("homepage.module_today_lysts.title");
  useEffect(function () {
    function calculateAdditionalTexts() {
      if (!text.current || !container.current) {
        return;
      }

      var textNode = text.current;
      var containerNode = container.current;
      var containerWidth = containerNode.getBoundingClientRect().width;
      var textWidth = textNode.getBoundingClientRect().width;
      var additionalTexts = Math.ceil(containerWidth / textWidth);
      setRepeatedTexts(additionalTexts + 1);
      setTextWidth(textWidth);
    }

    calculateAdditionalTexts();
    globals.window.addEventListener("resize", calculateAdditionalTexts);
    return function () {
      globals.window.removeEventListener("resize", calculateAdditionalTexts);
    };
  }, [text, container]);
  return React.createElement("div", {
    ref: container,
    className: classnames(styles.textContainer, className)
  }, React.createElement("span", {
    ref: text,
    className: classnames(styles.textTicker, _defineProperty({}, styles.beginAnimation, repeatedTexts > 0)),
    style: {
      animationDuration: "".concat(textWidth / speed, "s")
    }
  }, React.createElement(TickerText, {
    tickerText: tickerText
  }), React.createElement("span", {
    className: styles.textFake
  }, Array.from({
    length: repeatedTexts
  }).map(function (_, i) {
    return React.createElement(TickerText, {
      key: i,
      tickerText: tickerText,
      isPresentational: true
    });
  }))));
}